import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { get, isEmpty } from 'lodash';
import queryString from 'query-string';

import Account from 'components/Account';
import ChangePassword from 'components/Account/ChangePassword';
import CompanyInformation from 'components/Account/CompanyInformation';
import DiamondColumnListing from 'components/Account/ManageDiamondSequence';
import MobileAccount from 'components/Account/MobileAccount';
import PersonalInformation from 'components/Account/PersonalInformation';
import Dashboard from 'components/Dashboard/index';
import Compare from 'components/DiamondCompare';
import DiamondList from 'components/DiamondList';
import MadeInBotswana from 'components/MadeInBotswana';
import MyDemand from 'components/MyDemand/index';
import Offer from 'components/Offer';
import QuickSearch from 'components/QuickSearch';
import SavedSearch from 'components/SavedSearch';
import NotificationDropdown from 'components/common/Header/NotificationDropdown';

import UtilService from 'services/util';

import MainApp from 'App';

import BidList from '../components/DiamondList/BidList';
import NewArrivalBidIt from '../components/NewArrivalBidIt';
import { authorizedPages, LOCAL_STORAGE_VAR } from '../constants/Common';
import DiamondSearch from '../containers/DiamondSearch';

export default class FrontRoute extends Component {
  state = {
    currentUrl: window.location.pathname,
  };

  redirectPage = () => {
    const currentUrl = window.location.pathname.split('/');
    const path = currentUrl[1];

    if (path && path === 'device') {
      const values = queryString.parse(this.props.location.search);
      if (values && values.token) UtilService.setLocalStorageItem(values.token, `${LOCAL_STORAGE_VAR}-token`);
    }

    const isAuthPage = authorizedPages.includes(path);
    const isTrusted = localStorage.getItem(`${LOCAL_STORAGE_VAR}-isTrusted`);

    const isLoggedInUser = localStorage.getItem(`${LOCAL_STORAGE_VAR}-token`) && localStorage.getItem(`${LOCAL_STORAGE_VAR}-user`);

    if (isAuthPage) {
      if (isLoggedInUser && isLoggedInUser.length && isTrusted === 'false') {
        return <Redirect to="/verify-otp" />;
      } else if (!isLoggedInUser || !isLoggedInUser.length) {
        window.location.assign('/signin');
      }
    }
  };

  componentDidUpdate(newProps) {
    if (newProps.location.pathname && this.state.currentUrl !== newProps.location.pathname) {
      this.setState({ currentUrl: newProps.location.pathname });
    }
  }

  render() {
    if (window.drift) {
      window.drift.on('campaign:dismiss', () => { });

      if (window.drift && window.drift.api) {
        window.drift.api.widget.hide();
      }
    }

    const pagePermissions = this.props.commonData.pagePermission();
    const isMobile = window.innerWidth <= 767;
    return (
      <MainApp loading={this.props.commonData.loading}>
        <Switch>
          {this.redirectPage()}
          {pagePermissions?.dashboard?.view && <Route exact path="/dashboard" component={Dashboard} />}
          <Route path="/diamond-list" component={DiamondList} />
          {isMobile && <Route exact path="/account/saved-search" component={SavedSearch} />}
          {isMobile && <Route exact path="/account/my-demand" component={MyDemand} />}
          {pagePermissions?.quickSearch?.view && <Route exact path="/quick-search" component={QuickSearch} />}
          {isMobile && <Route exact path="/account/personal-information" component={PersonalInformation} />}
          {isMobile && <Route exact path="/account/company-profile" component={CompanyInformation} />}
          {isMobile && <Route exact path="/account/change-password" component={ChangePassword} />}
          {pagePermissions?.compare?.view && <Route exact path="/compare" component={Compare} />}
          {isMobile && <Route exact path="/account/change-password" component={ChangePassword} />}
          {pagePermissions?.compare?.view && <Route exact path="/compare" component={Compare} />}
          <Route exact path="/account" component={isMobile ? MobileAccount : Account} />

          {isMobile ? (
            <Route exact path="/account/cart" component={DiamondList} />
          ) : (
            <Route exact path="/account/cart" component={Account} />
          )}
          {isMobile ? (
            <Route exact path="/account/watchlist" component={DiamondList} />
          ) : (
            <Route exact path="/account/watchlist" component={Account} />
          )}
          {isMobile ? (
            <Route exact path="/account/office-list" component={DiamondList} />
          ) : (
            <Route exact path="/account/office-list" component={Account} />
          )}
          {isMobile ? (
            <Route exact path="/account/quote-list" component={Offer} />
          ) : (
            <Route exact path="/account/quote-list" component={Account} />
          )}
          <Route exact path="/account/enquiry" component={Account} />
          <Route exact path="/account/saved-search" component={Account} />
          <Route exact path="/account/my-demand" component={Account} />
          <Route exact path="/account/notification" component={Account} />
          <Route exact path="/account/reminder" component={Account} />
          <Route exact path="/account/my-comment" component={Account} />
          <Route exact path="/account/my-order" component={Account} />
          <Route exact path="/account/my-purchase" component={Account} />
          {isMobile ? (
            <Route exact path="/account/confirm-list" component={DiamondList} />
          ) : (
            <Route exact path="/account/confirm-list" component={Account} />
          )}
          <Route exact path="/account/profile" component={Account} />
          <Route exact path="/account/profile/manage-user" component={Account} />
          <Route exact path="/account/profile/manage-address" component={Account} />
          {isMobile ? (
            <Route exact path="/account/profile/diamond-sequence" component={DiamondColumnListing} />
          ) : (
            <Route exact path="/account/profile/diamond-sequence" component={Account} />
          )}
          {pagePermissions?.matchPair?.view && <Route exact path="/match-pair" component={DiamondList} />}
          <Route exact path="/upcoming" component={DiamondList} />
          {pagePermissions?.searchDiamond?.view && (
            <Route exact path="/diamond-search/:id?" component={DiamondSearch} />
          )}
          <Route exact path="/search-bid-diamond/:id?" component={DiamondSearch} />
          {pagePermissions?.fancySearch?.view && <Route path="/fancy-search" component={DiamondSearch} />}
          <Route exact path="/made-in-botswana" component={MadeInBotswana} />
          {isMobile && <Route exact path="/notification" component={NotificationDropdown} />}
          <Route exact path="/best-buy" component={DiamondList} />
          <Route exact path="/new-arrivals" component={DiamondList} />
          {pagePermissions?.fancySearch?.view && <Route exact path="/new-arrival-bid-it" component={NewArrivalBidIt} />}
          {pagePermissions?.fancySearch?.view && <Route exact path="/my-bid" component={BidList} />}
          <Route exact path="/featured-stone" component={DiamondList} />
        </Switch>
      </MainApp>
    );
  }
}
